import Vue from '../vue';
import axios from '../axios';
import eqNode from 'eqnode';

export const hashMapClearAll = (hashMap, except) =>
  Object.keys(hashMap)
    .filter(key => Array.isArray(except) ? except.includes(key) : (except || {})[key] !== undefined)
    .reduce((acc, key) => { acc[key] = hashMap[key]; return acc; }, {});

export const hashMapAddWithKey = (hashMap, key, { children, ...obj }) => ({ // eslint-disable-line
  ...hashMap,
  [key]: obj,
})

var keyTranslator = {
  drugstrength: 'strength',
  drugndc: 'ndcnum',
  drugform: 'form',
  drugbrand: 'brand',
  uscform: 'form',
  uscbrand: 'brand',
  uscstrength: 'strength',
  uscndc: 'ndcnum',
};

var getIdentificator = (item) => {
  if (!item.type)
    return item.id

  var key = keyTranslator[item.type.toLowerCase()];
  return item[key] || item.id;
}

export const createItemSearchId = item => [(item.type || ''), getIdentificator(item)].filter(f => f).join('/');
export const createSearchId = item => item.getParents && [item, ...item.getParents()]
  .reverse()
  .map(f => createItemSearchId(f.item))
  .filter(f => f)
  .join('/');

const noChildrenTypes = {
  dxname: true,
  drugndc: true,
  procdescrip: true,
  cohort: true,
  tag: true,
};
export const isNoChildItem = item => noChildrenTypes[item.type?.toLowerCase()];

export const loadChildNodes = (item, searchWord) => {
  if (!item.item.children) {
    if (item.item.id) {
      var { id, type, path, brand, form, strength, chain } = item.item;

      return axios.get('/Analytics/Cohort/CriteriaSearchChildren', { params: { query: searchWord, id, type, path, brand, form, strength, chain } })
        .then(({ data }) => {
          item.item.children = data;
          data.forEach(f => {
            item.addChild({
              ...f,
              children: isNoChildItem(f) ? undefined : f.children,
            })
          });
          item.forEach(f => f.item.search = f.item.search || createSearchId(f));
          Vue.set(item, 'errorLoading', false);
        })
        .catch(() => Vue.set(item, 'errorLoading', true));
    } else {
      item.item.children = undefined;
    }
  }
  return Promise.resolve();
}

export const getSearchValues = label => {
  if (label.toLowerCase().startsWith('ndc ')) {
    return ['', label]
  } else if (!label.toLowerCase().includes('(icd')) {
    var regex = /(.*)\(([^)]+)*\).*$/g;
    return [label.replace(regex, '$1'), label.replace(regex, '$2')];
  } else {
    return [label.split(' | ')[0]]
  }
}

export const pasteSplitted = (splitted, categorySettings) => splitted
  .map(query => axios.get('/Analytics/Cohort/CriteriaSearch', { params: { query, ...categorySettings } })
    .then(({ data }) => {
      var [text, icd] = getSearchValues(query.toLowerCase());
      var allEvents = eqNode.fromObject({ children: Object.values(data).filter(f => f).flatMap(f => f) })
        .toArray()
        .filter(f => f.label);

      var q = text.toLowerCase();
      icd = icd?.toLowerCase();
      return allEvents.find(f => f.label.toLowerCase().includes(q) && (!icd || f.label.toLowerCase().includes(`(${icd})`))) || { label: query, type: 'bad-code', search: `error-${query}` };
    })
    .catch(console.error));

export const createRootData = data => {
  var translator = {
    uscDetails: 'USC',
    details: 'Drugs',
    diagnosisGroup: 'Diagnoses',
    procedures: 'Procedures',
    physicianType: 'Physician Types',
  };

  data = Object.entries(data)
    .reduce((acc, [key, values]) => {
      acc[key] = (translator[key] && (values || []).length === 100) ? [...values, { type: 'limit-100-leaf' }] : values;
      return acc;
    }, {});

  var dataEntries = Object.entries({
    ...data,
    details: [
      ...(data.classes ? [{ label: 'Class Name', children: data.classes }] : []),
      ...(data.details || []),
    ],
    procedures: [
      ...(data.procClass ? [{ label: 'Procedure Class', children: data.procClass }] : []),
      ...(data.procedures ? [{ label: 'Procedure Name', children: data.procedures }] : []),
    ],
    classes: undefined,
    procClass: undefined,
  })
    .filter(([_, children]) => (children || []).any()); // eslint-disable-line


  return dataEntries
    .map(([label, children]) => ({
      label: translator[label] || label,
      children: children?.map(f => ({
        ...f,
        children: isNoChildItem(f) ? undefined : f.children,
      }))
    }));
}

export const filterTags = (tags, searchWord) => (
  (tags || [])
    .filter(f => f.toLowerCase().includes(searchWord.toLowerCase().trim()))
    .map(label => ({ label, type: 'tag', search: `tag/${label}` })));

export const filterCohorts = (cohorts, searchWord) => (
  (cohorts || [])
    .filter(cohort => (cohort.name || '').toLowerCase().includes((searchWord || '').toLowerCase().trim()))
    .map(cohort => ({
      id: cohort.id,
      label: cohort.name,
      type: 'cohort',
      search: `cohort/${cohort.id}`,
      cohort: cohort.cohort
    })));

export const findDPDItem = (items, search) => {
  if (!search || !items) return;
  var searchLowerCase = search.toLowerCase();
  return items.find(f => f.search?.toLowerCase() === searchLowerCase);
}

export const DEFAULT_LOADING_TEXT = "Loading...";
export const MIN_SEARCH_LENGTH = 4;
export const TYPING_TIMEOUT = 200;
export const STR_SPLITTER = "|||";